define('viewModels/privileged/qm/policies/editors/CheckedListEditorView',[
    'lib/knockout',
    'viewModels/ViewModel'
], function (ko, ViewModel) {
    'use strict';

    /**
     * The CheckedListEditorView class.
     * This viewModel provides a dataContext for the checkedValue and checked data-bindings
     * in order to create a list of checkboxes that populate an array with values.
     * @class
     */
    var CheckedListEditorView = ViewModel.extend(function () {
        var self = this;

        self.allItemsList = ko.observableArray();
        self.selectedItemsList = ko.observableArray();

        self.getDisplayString = function (item) {
            return item;
        };

        self.init = function (allItemsList, selectedItemsList) {

            if (allItemsList) {
                self.allItemsList(allItemsList);
            }

            if (selectedItemsList) {
                self.selectedItemsList(selectedItemsList);
            }
        };
    });

    return CheckedListEditorView;
});

